export const BOT_PROVIDER_METADATA_KEYS = {
    avatarIconName: "avatarIconName",
    widgetIconName: "widgetIconName",
    backgroundImageName: "backgroundImageName",
} as const;
